export default __webpack_public_path__ + "static/media/slider-img3.da866b12.png";